<template>
  <v-card id="tax-gyp-patrimoniales" class="px-4 pt-2 pb-4 my-0 elevation-0">
    <v-card-title class="px-1">
      <h1 class="card-title">
        Ganancias y pérdidas patrimoniales derivadas de transmisiones de otros elementos
        patrimoniales
      </h1>
    </v-card-title>

    <v-card-text class="pt-0 pb-3 px-3">
      <v-alert color="softInfo" icon="mdi-information" class="mt-4 mb-5">
        En este apartado se deben introducir todos aquellas ganancias y pérdidas patrimoniales que
        no tienen su sección en particular. Se pueden agregar todas juntas, o separarlas en varios
        conceptos dentro de la misma casilla, como se muestra a continuación.
      </v-alert>

      <div id="tax-gyp-patrimoniales-rows">
        <h1 class="tax-gyp-patrimoniales-rows-title pt-2">Saldo de divisas. Movimientos FX</h1>
        <SomePositionIncomplete />
        <GypPatrimonialesRow
          type="fx"
          :boxes="gypPatrimoniales.fx.boxes"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />

        <template v-if="yearSelected < 2022">
          <h1 class="tax-gyp-patrimoniales-rows-title pt-2">Criptodivisas</h1>
          <GypPatrimonialesRow
            type="crypto"
            :boxes="gypPatrimoniales.crypto.boxes"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </template>

        <h1 class="tax-gyp-patrimoniales-rows-title pt-2">Opciones</h1>
        <GypPatrimonialesRow
          type="options"
          :boxes="gypPatrimoniales.options.boxes"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />

        <template v-if="isAdminOrTesterRoleUser">
          <h1 class="tax-gyp-patrimoniales-rows-title pt-2">CFDs</h1>
          <GypPatrimonialesRow
            type="cfd"
            :boxes="gypPatrimoniales.cfd.boxes"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </template>

        <h1 class="tax-gyp-patrimoniales-rows-title pt-2">Materias primas</h1>
        <GypPatrimonialesRow
          type="commodity"
          :boxes="gypPatrimoniales.commodity.boxes"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import GypPatrimonialesRow from '@/views/components/tax/taxDocs/renta/GyPPatrimonialesRow'
import SomePositionIncomplete from '@/views/components/common/positions/SomePositionIncomplete.vue'

export default {
  components: { GypPatrimonialesRow, SomePositionIncomplete },
  props: {
    gypPatrimoniales: {
      type: Object,
      default: () => {},
    },
    yearSelected: {
      type: String,
      default: null,
    },
    hideDataNoPlanUser: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['isAdminOrTesterRoleUser']),
  },
}
</script>

<style lang="scss">
#tax-gyp-patrimoniales-rows {
  h1.tax-gyp-patrimoniales-rows-title {
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
